import { JsonConverter } from '../JsonConverter'

export class Prospecto implements JsonConverter {

  private _peso: number
  private _talla: number
  private _sexo: string
  private _codigoOcupacion: Ocupacion
  private _edad: number
  private _id: string
  private _imc: number

  constructor(id: string, peso: number, talla: number, sexo: string, codigoOcupacion: Ocupacion, edad: number, imc: number) {
      this._peso = peso
      this._talla = talla
      this._sexo = sexo
      this._codigoOcupacion = codigoOcupacion
      this._edad = edad
      this._id = id
      this._imc = imc
  }

  get peso(): number {
    return this._peso
  }

  get talla(): number {
    return this._talla
  }

  get sexo(): string {
    return this._sexo
  }

  get codigoOcupacion(): Ocupacion {
    return this._codigoOcupacion
  }

  get edad(): number {
    return this._edad
  }

  get id(): string {
    return this._id
  }

  get imc(): number {
    return this._imc
  }

  toJson(): any {
    return {
      id: this.id,
      peso: this.peso,
      talla: this.talla,
      sexo: this.sexo,
      codigoOcupacion: this.codigoOcupacion.nombre,
      edad: this.edad
    }
  }
}

export class Ocupacion {

  private _id: string
  private _nombre: string
  private _clasificaciones: string[]

  constructor(id: string, nombre: string, clasificaciones: string[]) {
    this._id = id
    this._nombre = nombre
    this._clasificaciones = clasificaciones
  }

  get id(): string {
    return this._id
  }

  get nombre(): string {
    return this._nombre
  }

  get clasificaciones(): string[] {
    return this._clasificaciones
  }
}



// WEBPACK FOOTER //
// ./src/app/dominio/prospecto.ts